import { CloseRounded } from '@mui/icons-material'
import { Button, DialogActions, DialogContent, DialogTitle, Grid, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import { deleteCourse } from '../../../../../redux/actions/courses'
import { CancelButton, DeleteButton } from '../../../../shared/components/inputs'
import { StyledDialog } from '@/contexts/shared/styles/StyledDialog'

interface DialogProps {
  courseSelected: number | boolean
  openDeleteCourse: boolean
  setOpenDeleteCourse: (open: boolean) => void
}

const ConfirmDeleteDialog = ({ courseSelected, openDeleteCourse, setOpenDeleteCourse }: DialogProps) => {
  const { t } = useTranslation(['global'])
  const dispatch = useDispatch()

  return (
    <StyledDialog
      open={openDeleteCourse}
      onClose={() => setOpenDeleteCourse(!openDeleteCourse)}
      aria-labelledby="course-dialog-title"
      aria-describedby="course-dialog-description"
    >
      <DialogTitle id="course-dialog-title">
        <Grid container justifyContent="space-between">
          <Typography variant="h6">
            {t('delete')} {t('course')}
          </Typography>
          <Button onClick={() => setOpenDeleteCourse(!openDeleteCourse)} color="primary" variant="text">
            <CloseRounded />
          </Button>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 2 }}>
        <Typography>{t('confirm-delete')}</Typography>
      </DialogContent>
      <DialogActions>
        <CancelButton onClick={() => setOpenDeleteCourse(!openDeleteCourse)}>{t('cancel')}</CancelButton>
        <DeleteButton
          autoFocus
          id="btn-handleldelete"
          //endIcon={<Delete/>}
          onClick={() => {
            dispatch(deleteCourse(courseSelected))
            setOpenDeleteCourse(!openDeleteCourse)
          }}
        >
          {t('delete')}
        </DeleteButton>
      </DialogActions>
    </StyledDialog>
  )
}

export default ConfirmDeleteDialog
